import { differenceWith, isEqual } from 'lodash';

export const removeIndex = <T>(arr: T[], indexToRemove: number): T[] => {
    if (indexToRemove < 0) {
        return arr;
    }
    const clone = [...arr];
    clone.splice(indexToRemove, 1);
    return clone;
};

export const removeFirst = <T>(arr: T[], predicate: (value: T) => boolean): T[] => {
    const indexToRemove = arr.findIndex(predicate);
    return removeIndex(arr, indexToRemove);
};

export const replaceIndex = <T>(arr: T[], index: number, replacer: (value?: T) => T) => {
    if (index < 0) {
        return arr;
    }
    const clone = [...arr];
    clone.splice(index, 1, replacer(arr[index]));
    return clone;
};

// ignores order, performs deep comparison on objects
export const hasSameValues = <T>(arr1: T[], arr2: T[]): boolean => {
    const missingInFirst = differenceWith(arr1, arr2, isEqual);
    if (missingInFirst.length) {
        return false;
    }
    const onlyInFirst = differenceWith(arr2, arr1, isEqual);
    if (onlyInFirst.length) {
        return false;
    }
    return true;
};
